<template>
  <div id="header">
    <div class="navbar">
      <div class="container">
        <div class="logo">
          <router-link :to="{ name: 'index' }">
            <img src="@/assets/images/logo.svg" />
          </router-link>
        </div>
        <div class="appname" v-show="$route.name !== 'index'">{{ theme }}</div>
        <div class="nav-user pull-right">
          <div
            class="search-bar"
            :class="[searchFocus ? 'search-focus' : '', active ? 'active' : '']"
            v-if="authenticated"
          >
            <i
              class="iconfont icon-search"
              @click="$refs.searchInput.focus()"
            ></i>
            <input
              ref="searchInput"
              type="search"
              class="search-input"
              placeholder="搜索应用/我的云盘/我的群组"
              v-model.trim="searchName"
              @keyup.enter="search"
              @keyup.esc="searchDelete"
              @focus="searchInput"
              @blur="searchBlur"
              required
            />
            <i
              class="icon-delete iconfont icon-close"
              @click="searchDelete"
            ></i>
            <button type="button" class="btn btn-primary" @click="searchResult">
              <i class="ti-angle-right"></i>
            </button>
            <div class="search-result-list">
              <dl>
                <dt>应用</dt>
                <dd v-show="appSearchLoading">正在加载，请稍后……</dd>
                <dd v-show="appSearchNothing">未搜索到应用</dd>
                <router-link
                  :to="{ name: app.app_function_link }"
                  v-for="app in apps"
                  :key="app.id"
                  tag="dd"
                >
                  <img class="icon" :src="app.app_icon" :alt="app.app_name" />
                  {{ app.app_name }}
                </router-link>
              </dl>
              <dl>
                <dt>文件夹 / 文件</dt>
                <dd v-show="fileSearchLoading">正在加载，请稍后……</dd>
                <dd v-show="fileSearchNothing">未搜索到文件和文件夹</dd>
                <dd v-for="folder in folders" :key="folder.number">
                  <div class="file-left">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="'#icon-folder'" />
                    </svg>
                  </div>
                  <div class="file-right">
                    <div
                      class="file-right-top"
                      :title="folder | formatData"
                      @click="goToFolder(folder)"
                    >
                      <span class="file-float-left">{{
                        folder | formatData
                      }}</span>
                      <span class="file-float-right">跳转位置</span>
                    </div>
                    <div
                      class="file-right-bottom"
                      :title="folder.position"
                      @click="goToFolder(folder)"
                    >
                      <span class="file-float-left">{{ folder.position }}</span>
                      <span class="file-float-right">跳转位置</span>
                    </div>
                  </div>
                </dd>
                <dd v-for="file in files" :key="file.number">
                  <div class="file-left">
                    <svg class="icon" aria-hidden="true">
                      <use
                        :xlink:href="
                          '#icon-' +
                          getIcon(file.type, file.file_type, file.file_ext)
                        "
                      />
                    </svg>
                  </div>
                  <div class="file-right">
                    <div
                      class="file-right-top"
                      :title="file | formatData"
                      @click="goToPreview(file)"
                    >
                      <span class="file-float-left">{{
                        file | formatData
                      }}</span>
                      <span class="file-float-right">打开文件</span>
                    </div>
                    <div
                      class="file-right-bottom"
                      :title="file.position"
                      @click="goToFolder(file)"
                    >
                      <span class="file-float-left">{{ file.position }}</span>
                      <span class="file-float-right">跳转位置</span>
                    </div>
                  </div>
                </dd>
              </dl>
              <dl>
                <dt>群组</dt>
                <dd v-show="groupSearchLoading">正在加载，请稍后……</dd>
                <dd v-show="groupSearchNothing">未搜索到群组</dd>
                <router-link
                  :to="{
                    name: 'group',
                    params: { groupNumber: group.group_number },
                  }"
                  v-for="group in groups"
                  :key="group.group_number"
                  tag="dd"
                >
                  <img :src="group.group_logo" class="search-avator avator1" />
                  {{ group.group_name }}
                </router-link>
              </dl>
              <router-link
                class="search-more"
                v-show="searchName"
                tag="div"
                :to="{ name: 'searchFile', query: { search: searchName } }"
                >查看更多内容</router-link
              >
            </div>
          </div>
          <div class="systmelist" v-show="authenticated">
            <div class="dropdown">
              <a
                class="dropdown-toggle"
                id="dropdownMenu1"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              >
                <i class="iconfont icon-gridview"></i>
              </a>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenu1"
              >
                <div
                  class="list"
                  v-for="app in applications"
                  :key="app.app_number"
                >
                  <a @click="goToApp(app.app_function_link)">
                    <i>
                      <img class="icon" :src="app.app_icon" />
                    </i>
                    <p>{{ app.app_name }}</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="navbar-user" v-show="authenticated">
            <div class="dropdown">
              <div
                class="dropdown-toggle"
                id="dropdownMenu1"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
                @click="toggleAvatar"
              >
                <div class="avator">
                  <img :src="userInfo.avatar" />
                </div>
              </div>
              <ul
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenu1"
              >
                <li>
                  <div class="profile">
                    <div
                      class="profile-avator"
                      :style="userInfo.avatar | styleFilter"
                      id="view"
                      @click="cropper"
                    >
                      <div class="camera">
                        <i class="ti-camera"></i>
                      </div>
                    </div>
                    <div class="detail">
                      <div class="nick">{{ userInfo.name }}</div>
                      <div class="username">{{ userInfo.email }}</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="disk-wrap">
                    <div class="disk">
                      <span
                        :style="
                          'width:' +
                          (used_percent > 100 ? 100 : used_percent) +
                          '%;'
                        "
                      ></span>
                    </div>
                    <div class="disk-info-bottom">
                      个人云盘 {{ used_space }}/{{ total_space }}
                      <!-- <a
                       v-if="right__user_extend_capacity"
                        data-toggle="modal"
                        data-target="#expand"
                        data-whatever="#expand-self"
                        >扩容</a
                      > -->
                    </div>
                  </div>
                </li>
                <li>
                  <div class="disk-wrap">
                    <div class="disk">
                      <span
                        :style="'width:' + group_used_percent + '%;'"
                      ></span>
                    </div>
                    <div class="disk-info-bottom">
                      群盘 {{ group_used_space }}/{{ group_total_space }}
                      <!-- <a
                       v-if="right__capacity_add_public_capacity"
                        data-toggle="modal"
                        data-target="#expand"
                        data-whatever="#expand-group"
                        >扩容</a
                      > -->
                    </div>
                  </div>
                </li>
                <li role="separator" class="divider"></li>
                <li @click="goToApp('persona')">
                  <a>个人中心</a>
                </li>
                <li @click="goToApp('personaInfo')">
                  <a>我的帐号</a>
                </li>
                <li
                  @click="goToApp('changePwd')"
                  v-if="userInfo.user_type === 2"
                >
                  <a>修改密码</a>
                </li>
                <li>
                  <a @click="logout">退出</a>
                </li>
              </ul>
            </div>
          </div>
          <a
            @click="goToLogin"
            class="navbar-login-btn"
            v-show="!authenticated"
          >
            <i class="ti-user hidden-lg"></i>
            <p class="hidden-xs">登录</p>
          </a>
        </div>
      </div>
    </div>
    <cropper :imgSrc="imgSrc" @complete="complete"></cropper>
  </div>
</template>

<script>
import { setRedirect } from "@/utils/auth";
import { formatData, positionFilter, bytesToSize2 } from "@/utils/index";
import { getIcon } from "@/utils/icon";
import debounce from "lodash.debounce";
import { appList } from "@/api/common/index";
import { getGroups, getCapacit } from "@/api/group/group";
import { resourceSearch } from "@/api/drive/drive";
import { config } from "@/config/index";
export default {
  name: "Header",
  components: {
    cropper: () => import("@/views/Common/cropper"),
  },
  data() {
    return {
      appSearchLoading: false,
      appSearchNothing: false,
      fileSearchLoading: false,
      fileSearchNothing: false,
      groupSearchLoading: false,
      groupSearchNothing: false,
      imgSrc: "",
      active: false,
      searchFocus: false,
      searchName: "",
      apps: [],
      files: [],
      folders: [],
      groups: [],
      group_used_space: "获取中...",
      group_total_space: "获取中...",
      group_used_percent: 0,
      used_space: "获取中...",
      total_space: "获取中...",
      used_percent: 0,
      showAtatar: false,
    };
  },
  created() {
    this.getApps();
    this.debouncedSearch = debounce(this.search, 500);
  },
  computed: {
    right__user_extend_capacity () {
      return this.$store.getters.right__user_extend_capacity
    },
    right__capacity_add_public_capacity () {
      return this.$store.getters.right__capacity_add_public_capacity
    },
    applications() {
      return this.$store.state.app.applications;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    theme() {
      return this.$store.state.app.theme;
    },
    authenticated() {
      return this.$store.state.user.authenticated;
    },
    name() {
      return this.data;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    userGroupNumber() {
      return this.userInfo.group_number;
    },
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name) {
        this.searchName = "";
      }
    },
    searchName(newValue) {
      if (newValue.trim()) {
        this.debouncedSearch();
      }
    },
  },
  filters: {
    styleFilter(value) {
      return `background: url(${value}) no-repeat 0px 0px / 60px 60px #999;`;
    },
    formatData: formatData,
    positionFilter: positionFilter,
  },
  methods: {
    toggleAvatar() {
      this.getCapacit();
      this.showAtatar = !this.showAtatar;
      this.$store.dispatch("UserInfo");
    },
    getCapacit() {
      getCapacit()
        .then((res) => {
          if (res.status_code === 200) {
            // 云盘
            if (
              "self_used_space" in res.entity &&
              "self_total_space" in res.entity
            ) {
              this.used_space = bytesToSize2(res.entity.self_used_space);
              this.total_space = bytesToSize2(res.entity.self_total_space);
              this.used_percent = Math.round(
                (res.entity.self_used_space / res.entity.self_total_space) * 100
              );
            } else {
              this.used_space = this.total_space = "获取失败";
            }
            // 群盘
            if (
              "group_used_space" in res.entity &&
              "group_total_space" in res.entity
            ) {
              if (res.entity.group_total_space == -1) {
                this.group_used_space = bytesToSize2(
                  res.entity.group_used_space
                );
                this.group_total_space = "无限制";
                this.group_used_percent = 0;
              } else {
                this.group_used_space = bytesToSize2(
                  res.entity.group_used_space
                );
                this.group_total_space = bytesToSize2(
                  res.entity.group_total_space
                );
                this.group_used_percent = Math.round(
                  (res.entity.group_used_space / res.entity.group_total_space) *
                    100
                );
              }
            } else {
              this.group_used_space = this.group_total_space = "获取失败";
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },

    showExpand() {
      $("#expand").modal("show");
    },
    getApps() {
      appList()
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setApps", res.entity);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    /**
     * 跳转到应用
     * 如果是当前路由，则刷新当前页面
     */
    goToApp(name) {
      if (this.$route.name === name) {
        this.$router.push({
          name: name,
          query: { s: new Date().getTime() },
          params: {},
        });
        return false;
      }
      if(name.startsWith('http')){
        window.open(name)
      } else {
        this.$router.push({
          name: name,
        });
      }      
    },
    /**
     * 当点击登录的时候，用户所在路由为①sharelink（后续可能增加更多URL）时，添加当前地址为登录后的重定向地址
     */
    goToLogin() {
      if (["sharelink"].indexOf(this.$route.name) > -1) {
        setRedirect(`${window.location.origin}${this.$route.fullPath}`);
      }
      // 直接跳转到本地登录页面
      // this.$router.push({ name: "login" });

      // 直接跳转到第三方登录页面
      const routeUrl = this.$router.resolve({
        name: "login_terminal",
      });
      window.location.href =
        `${config.loginUrl}` +
        encodeURIComponent(`${window.location.origin}${routeUrl.href}`);
    },
    goToPreview(file) {
      let group_number = file.group_number
        ? file.group_number
        : this.userGroupNumber;
      let routeUrl = this.$router.resolve({
        name: "preview",
        params: { number: file.number, group_number: group_number },
      });
      window.open(routeUrl.href, "_blank");
    },
    cropper() {
      $("#filebtn").click();
    },
    complete() {
      this.$store.dispatch("UserInfo");
    },
    // 跳转到云盘/群盘
    goToFolder(file) {
      if (file.group_number) {
        // 跳转到群盘
        this.$router.push({
          name: "groupDisk",
          params: {
            groupNumber: file.group_number,
          },
          query: {
            type: "file",
            number: file.parent_number,
            s: new Date().getTime(),
          },
        });
      } else {
        //跳转到云盘
        this.$router.push({
          name: "recdrive",
          query: {
            tab: "file",
            number: file.parent_number,
            disk_type: file.disk_type,
            s: new Date().getTime(),
          },
        });
      }
    },
    searchResult() {
      this.$router.push({
        name: "searchFile",
        query: { search: this.searchName },
      });
    },
    getIcon(type, file_type, file_ext) {
      return getIcon(type, file_type, file_ext);
    },
    search() {
      this.appSearchNothing = false;
      this.appSearchLoading = true;
      this.appSearch();
      this.fileSearchNothing = false;
      this.fileSearchLoading = true;
      this.resourceSearch();
      this.groupSearchNothing = false;
      this.groupSearchLoading = true;
      this.getGroups();
    },
    appSearch() {
      this.apps = [];
      appList({
        searchName: this.searchName,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.appSearchLoading = false;
            if (this.searchName) {
              // 仅显示搜索结果中的2个
              this.apps = res.entity;
            } else {
              // 显示默认的应用
              this.apps = res.entity.filter((item) => item.is_default);
            }
            this.appSearchNothing = this.apps.length > 0 ? false : true;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    async resourceSearch() {
      // 搜索文件
      this.files = [];
      const file_res = await resourceSearch({
        group_number: "all",
        category: "file",
        searchName: this.searchName,
        disk_type: "cloud",
        offset: 0,
        limit: 3,
      })
        .then((res) => {
          if (res.status_code === 200) {
            return res;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
      if (file_res.entity.total > 0) {
        // 获取文件路径
        this.getFilePath(file_res.entity.datas);
      }
      // 搜索文件夹
      this.folders = [];
      const folder_res = await resourceSearch({
        group_number: "all",
        category: "folder",
        searchName: this.searchName,
        disk_type: "cloud",
        offset: 0,
        limit: 3,
      })
        .then((res) => {
          if (res.status_code === 200) {
            return res;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });

      if (folder_res.entity.total > 0) {
        // 获取文件夹路径
        this.getFolderPath(folder_res.entity.datas);
      }
      this.fileSearchLoading = false;
      if (file_res.entity.total == 0 && folder_res.entity.total == 0) {
        this.fileSearchNothing = true;
      } else {
        this.fileSearchNothing = false;
      }
    },
    getFilePath(files) {
      this.files = files.map((file) => {
        let path =
          file.parent_number === "0" ? "/" : file.parent_path_name + "/";
        let ext = file.file_ext ? "." + file.file_ext : "";

        file.position = "云盘" + path + file.name + ext;
        return file;
      });
    },
    getFolderPath(folders) {
      this.folders = folders.map((folder) => {
        let path =
          folder.parent_number === "0" ? "/" : folder.parent_path_name + "/";

        folder.position = "云盘" + path + folder.name;
        return folder;
      });
    },
    getGroups() {
      this.groups = [];
      getGroups({
        search_name: this.searchName,
        group_review: "adopt",
        offset: 0,
        limit: 3,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.groupSearchLoading = false;
            this.groupSearchNothing = res.entity.total > 0 ? false : true;
            this.groups = res.entity.datas;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    logout() {
      this.$store
        .dispatch("LogOut")
        .then(() => {
          this.$router.push({ name: "index" });
          const iframe = window.document.createElement("iframe");
          iframe.style.display = "none";
          iframe.style.height = 0;
          iframe.src = "https://passport.ustc.edu.cn/logout";
          document.body.appendChild(iframe);
          // 3s之后删除
          setTimeout(() => {
            iframe.remove();
          }, 3000);
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    searchInput() {
      this.active = true;
      this.searchFocus = true;
      this.search();
    },
    searchDelete() {
      this.searchName = "";
    },
    searchBlur() {
      setTimeout(() => {
        this.active = false;
        this.searchFocus = false;
      }, 500);
    },
  },
};
</script>

<style scoped>
.avator1 {
  width: 30px;
  height: 30px;
}
.file-left {
  height: 34px;
  width: 40px;
  float: left;
}
.file-right {
  height: 34px;
  width: calc(100% - 40px);
  float: left;
}
dd {
  height: 50px;
  white-space: nowrap;
  overflow: hidden;
}
.file-right-top {
  height: 18px;
  line-height: 18px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-float-left {
  /* display: inline-block; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 60px);
}
.file-float-right {
  width: 60px;
}
.file-right-top:hover .file-float-left,
.file-right-bottom:hover .file-float-left {
  display: inline-block;
}
.file-right-top:hover .file-float-right,
.file-right-bottom:hover .file-float-right {
  display: inline-block;
}
.file-right-bottom {
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-float-right {
  display: none;
  float: right;
  font-size: 12px;
  color: #999;
}
</style>